import { Directive, Input, ElementRef, OnChanges } from '@angular/core';
import { assets } from '../assets';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: 'img[src]'
})
export class HashedAssetDirective implements OnChanges {
  @Input() src: string = '';

  constructor(private elementRef: ElementRef) {
  }

  ngOnChanges(changes: any) {
    if (changes.src && this.src) {
      if (assets[this.src]) {
        this.elementRef.nativeElement.setAttribute('src', assets[this.src]);
      } else {
        this.elementRef.nativeElement.setAttribute('src', this.src);
      }
    }
   }
}
